import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { extractIdFromSlug } from '@/shared/lib/utils/slug-utils';

export const useProjectSiteParams = () => {
  const { projectId: projectSlug, siteId: siteSlug } = useParams<{ projectId: string; siteId: string }>();

  return useMemo(() => {
    const extractedProjectId = projectSlug ? extractIdFromSlug(projectSlug) : null;
    const extractedSiteId = siteSlug ? extractIdFromSlug(siteSlug) : null;

    const projectId = extractedProjectId ?? undefined;
    const siteId = extractedSiteId ?? undefined;

    return {
      projectId,
      siteId,
      projectSlug,
      siteSlug,
      isValid: projectId !== undefined && siteId !== undefined
    };
  }, [projectSlug, siteSlug]);
};
